import Emitter from '@resources/js/helpers/Emitter'
import { addCss } from '@resources/js/helpers/styles'

class Toggle extends Emitter {
	constructor(
		triggerSelector,
		{ target: targetElOrSelector, toggleClass = 'active' } = {}
	) {
		super()
		this.toggleClass = toggleClass
		if (triggerSelector)
			this.trigger =
				triggerSelector instanceof HTMLElement
					? triggerSelector
					: document.querySelector(triggerSelector)

		const targetFromParam =
			targetElOrSelector instanceof HTMLElement
				? targetElOrSelector
				: document.querySelector(targetElOrSelector)
		this.target =
			targetFromParam || document.querySelector(this.trigger?.dataset.target)

		if (!this.target)
			throw new Error(
				`Error in Toggle. Cannot find target with selector ${targetElOrSelector} or data-attribute ${this.trigger?.dataset.target}`
			)

		this._clickListener = e => {
			e.currentTarget.blur()
			this.toggle()
		}

		this.trigger?.addEventListener('click', this._clickListener)
	}

	get active() {
		return this.target.classList.contains(this.toggleClass)
	}

	toggle() {
		this.target.classList.contains(this.toggleClass) ? this.hide() : this.show()
	}

	hide() {
		this.target.classList.remove(this.toggleClass)
		this.trigger?.classList.remove(this.toggleClass)

		this.emit('hide')
	}

	show() {
		this.target.classList.add(this.toggleClass)
		this.trigger?.classList.add(this.toggleClass)

		this.emit('show')
	}

	destroy() {
		this.trigger?.removeEventListener('click', this._clickListener)
	}
}

// Задача по рефакторінгу фунції https://app.clickup.com/t/86c96uv66
// TODO: find better solution
export class ScrollToggle extends Toggle {
	constructor(
		triggerSelector,
		{
			target: targetElOrSelector,
			toggleClass = 'active',
			transition = '0.3s',
		} = {}
	) {
		super(triggerSelector, {
			target: targetElOrSelector,
			toggleClass: toggleClass,
		})

		this._targetHeight = this.target.offsetHeight
		this.target.style.transition = transition
		this.target.style.overflow = 'hidden'
	}

	hide() {
		super.hide()
		this.target.style.height = '0'
	}

	show() {
		super.show()
		this.target.style.height = `${this._targetHeight}px`
	}
}

export class ToggleWithScroll extends Toggle {
	constructor(triggerSelector) {
		super(triggerSelector)
	}

	toggle() {
		super.toggle()
		this._scrollToViewport()
	}

	_scrollToViewport() {
		const offset = 150
		const bodyRect = document.body.getBoundingClientRect().top
		const elementRect = this.target.getBoundingClientRect().top
		const elementPosition = elementRect - bodyRect
		const offsetPosition = elementPosition - offset

		window.scrollTo({
			top: offsetPosition,
			behavior: 'smooth',
		})
	}
}

export class ToggleWithSmooth extends Toggle {
	constructor(
		triggerSelector,
		{ target, toggleClass, defaultHeight = 0, transitionTime = '0.5s' }
	) {
		super(triggerSelector, { target, toggleClass })

		this.defaultHeight = defaultHeight
		this.transitionTime = transitionTime

		addCss(this.target, {
			maxHeight: this.target.scrollHeight + 'px',
			overflow: 'hidden',
			transition: 'max-height ' + this.transitionTime,
		})
	}

	show() {
		super.show()
		this.target.style.maxHeight = this.target.scrollHeight + 'px'
	}

	hide() {
		super.hide()
		this.target.style.maxHeight = this.defaultHeight + 'px'
	}
}

export default Toggle
